import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';
import WindowVisibilityHelper from 'dashboard/helper/AudioAlerts/WindowVisibilityHelper';

const pendingReads = new Map();

export default {
  markMessagesRead: async (
    { commit, state },
    { id: conversationId, automatic = false }
  ) => {
    if (
      !WindowVisibilityHelper.isWindowVisible() ||
      (automatic && state.selectedChatId !== conversationId)
    )
      return;

    const request = Symbol();
    pendingReads.set(conversationId, request);
    try {
      const {
        data: {
          id,
          agent_last_seen_at: lastSeen,
          unread_count: unreadCount,
          messages,
        },
      } = await ConversationApi.markMessageRead({ id: conversationId });
      setTimeout(() => {
        if (pendingReads.get(conversationId) !== request) return;
        pendingReads.delete(conversationId);
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
          id,
          lastSeen,
          unreadCount,
          lastReadMessageId: messages[0]?.id ?? 0,
          isRead: true,
        });
      }, 4000);
    } catch (error) {
      if (pendingReads.get(conversationId) === request) {
        pendingReads.delete(conversationId);
      }
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    pendingReads.delete(id);
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
